module.exports = __webpack_public_path__ + "images/emoji/u7533.78a7403e602f23ddcd9e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u7533.png
// module id = R4bs
// module chunks = 24